<template>
  <div class="loginContainer">
    <div class="title">{{ $t("user.bind.visit") }}</div>
    <div class="formContainer">
      <div class="bindDes">
        <div class="icons">
          <div class="iconCircle weixin">
            <icon-font type="weixin" />
          </div>
          <span>{{ $t("user.bind.connect") }}</span>
          <div class="iconCircle xkool">
            <icon-font type="xkool" />
          </div>
        </div>
        <div class="des">
          {{
            !isEn
              ? "第一次使用微信登录时，您需要填写手机号和密码，以后您也可以使用手机号和密码登录。"
              : ""
          }}
        </div>
      </div>
      <a-form :form="form" @submit="handleSubmit">
        <phone-and-email-form-item class="phoneInput" />
        <captcha-form-item
          :phoneNumber="currentPhoneNumber"
          :dynamicCodeType="dynamicCodeType"
          :errHandler="errHandler"
        />
        <a-form-item>
          <a-button
            type="primary"
            block
            html-type="submit"
            class="radiusBtnFull"
            :loading="isSubmitting"
          >
            {{ $t("user.bind.submit") }}
          </a-button>
        </a-form-item>
        <div class="bindBackLogin">
          <span class="bindBackLoginBtn" @click="goTo(passwordLoginFormType)">
            {{ $t("user.bind.login") }}
          </span>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
/** 微信绑定表单 */
import IconFont from "@/components/IconFont";
import PhoneAndEmailFormItem from "./PhoneAndEmailFormItem";
import CaptchaFormItem from "./CaptchaFormItem";
import { FormType } from "@/models/user";
import { DynamicCodeType } from "@/models/user";
import { pickPhoneNumberOrEmail } from "@/utils/validator";
import UserApi from "@/api/user";
import { JwtUtil } from "@/utils/jwt";

export default {
  name: "WechatBindForm",
  components: {
    IconFont,
    PhoneAndEmailFormItem,
    CaptchaFormItem,
  },
  props: {
    goTo: {
      type: Function,
      default: () => {},
    },
    unionId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form: null,
      currentPhoneNumber: undefined,
      dynamicCodeType: DynamicCodeType.BIND,
      isSubmitting: false,
      passwordLoginFormType: FormType.PASSWORD_LOGIN,
      registeFormType: FormType.REGISTE,
    };
  },
  created() {
    this.form = this.$form.createForm(this, {
      name: "registe",
      onValuesChange: (_, values) => {
        if (values.phoneNumber !== undefined) {
          this.currentPhoneNumber = values.phoneNumber;
        }
      },
    });
  },
  mounted() {
    if (!this.unionId) {
      // 没有unionId 退出绑定，回到密码登录表单； 2表示2秒延时
      this.$message.warn("初始化失败，请重新扫码进入", 2, () => {
        // this.goTo(this.passwordLoginFormType);
      });
    }
  },
  computed: {
    isEn: function() {
      return this.$i18n.locale === "en-US";
    },
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      if (!this.unionId) {
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          /** 判断输入项是手机号还是邮箱 */
          const newValues = pickPhoneNumberOrEmail(values);
          this.isSubmitting = true;
          UserApi.bindWeixin({ ...newValues, unionId: this.unionId })
            .then((res) => {
              // 绑定成功,后端返回的null
              if (res.data && res.data.code) {
                this.$notification.error({ message: res.data.message });
                return;
              }
              // 绑定成功后用微信登录
              UserApi.weixinLogin(this.unionId)
                .then((response) => {
                  JwtUtil.setJwtToken(
                    (response.data.legal_entities[0].token || "").replace(
                      "Bearer ",
                      ""
                    )
                  );
                  window.location.href = "/";
                })
                .catch((e) => {
                  this.$message.error(e.message);
                });
            })
            .finally(() => {
              this.isSubmitting = false;
            });
        }
      });
    },
    errHandler(errorCode) {
      /** 此码为自定义错误码，表示用户未注册，跳转至注册表单 */
      if (errorCode && errorCode === 201000) {
        this.$message.warn(
          "您还没有注册账号，请先注册账号再进行微信绑定",
          2,
          () => {
            this.goTo(this.registeFormType);
          }
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../common.less";
</style>
